import { useState, useRef, useEffect } from "react"

// Vanta
import NET from "vanta/dist/vanta.net.min"
import * as THREE from "three"

// --------------------------------------------------------------------------------------------------------

const Vanta = ({ children, childrenRef }) => {
  const [vantaEffect, setVantaEffect] = useState(0)

  // Use Ref
  const vantaRef = useRef(null)

  useEffect(() => {
    if (!vantaEffect) {
      setVantaEffect(
        NET({
          el: childrenRef.current,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.0,
          minWidth: 200.0,
          scale: 1.0,
          scaleMobile: 1.0,
          color: 0x9a9a9a,
          maxDistance: 12.0,
          spacing: 20.0,
          backgroundColor: "#282A3A",
          THREE
        })
      )
    }
    return () => {
      if (vantaEffect) vantaEffect.destroy()
    }
  }, [vantaEffect])

  return <>{children}</>
}

export default Vanta
